module.exports = __webpack_public_path__ + "static/media/workingmemory-words-7.9393ff0e.mp3";